var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgScroll5 = function SvgScroll5(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "scroll_5_svg__scroll",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 227.3574 403.2455",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient",
    cx: -43.623,
    cy: -37.2857,
    r: 473.5353,
    gradientTransform: "translate(16.6177 -12.4205) rotate(4.1431)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1fbf8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239,
    stopColor: "#389f90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756,
    stopColor: "#6a5e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e45a2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-2",
    cx: -20.6044,
    cy: 308.8022,
    r: 95.0915,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#scroll_5_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-3",
    cx: -253.2198,
    cy: 94.6484,
    r: 491.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1fbf8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2739,
    stopColor: "#409592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#616a9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#764fa0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e45a2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-4",
    cx: -137.967,
    cy: 132.0989,
    r: 361.0635,
    xlinkHref: "#scroll_5_svg__radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-5",
    cx: -92.0262,
    cy: 133.6157,
    r: 341.233,
    xlinkHref: "#scroll_5_svg__radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-6",
    cx: -96.5315,
    cy: 43.1176,
    r: 432.0992,
    xlinkHref: "#scroll_5_svg__radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-7",
    cx: -183.8583,
    cy: 16.1372,
    r: 585.7377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1fbf8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e45a2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-8",
    cx: -99.1978,
    cy: 37.1538,
    r: 477.4603,
    xlinkHref: "#scroll_5_svg__radial-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-9",
    cx: 37.6813,
    cy: 24.0989,
    r: 136.3377,
    xlinkHref: "#scroll_5_svg__radial-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-10",
    cx: 76.7249,
    cy: 9.6733,
    r: 187.3578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ec492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e45a2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-11",
    cx: 99.1593,
    cy: 147.9231,
    r: 111.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55bab8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3059,
    stopColor: "#5dc3b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7972,
    stopColor: "#75dab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80e6b1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-12",
    cx: 164.8288,
    cy: -12.1337,
    r: 88.2215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#65d4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57c4c0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-13",
    cx: 193.4492,
    cy: 38.7578,
    r: 48.6295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#609fcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59c4c0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-14",
    cx: 236.8681,
    cy: 58.243,
    r: 78.6099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9282c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59b6c0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-15",
    cx: 16.8242,
    cy: 113.2103,
    r: 184.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ee5b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a5dd6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-16",
    cx: 6.956,
    cy: 119.044,
    r: 166.2905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4eddb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8360ca"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-17",
    cx: 45.6142,
    cy: -15.3543,
    r: 265.9925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dd6be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1924,
    stopColor: "#4fd2be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3875,
    stopColor: "#57c6c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5838,
    stopColor: "#63b1c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#7495c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9772,
    stopColor: "#8971c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c6cc8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-18",
    cx: 244.1868,
    cy: 222.2059,
    r: 179.4429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#924396"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5abdea"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-19",
    cx: -7.9451,
    cy: 206.2088,
    r: 138.2808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ec1b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9946,
    stopColor: "#858ce2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-20",
    cx: 217.6813,
    cy: 251.1758,
    r: 127.4927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#714aac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2931,
    stopColor: "#885cb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7444,
    stopColor: "#a673c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b17cc6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-21",
    cx: 267.4264,
    cy: 294.6074,
    r: 156.6053,
    gradientTransform: "translate(16.6177 -12.4205) rotate(4.1431)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c49c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    stopColor: "#6f4dc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4615,
    stopColor: "#7659c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6952,
    stopColor: "#836ed0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9286,
    stopColor: "#958adc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c94e0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-22",
    cx: 197.9011,
    cy: 375,
    r: 184.7468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9685d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3109,
    stopColor: "#9286d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6259,
    stopColor: "#8689d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942,
    stopColor: "#728dd8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d8ed9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-23",
    cx: 210.6886,
    cy: 320.1204,
    r: 135.2652,
    gradientTransform: "translate(16.6177 -12.4205) rotate(4.1431)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9062d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2373,
    stopColor: "#9066d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4778,
    stopColor: "#8f72d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7198,
    stopColor: "#8e87ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9615,
    stopColor: "#8da3ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8da8c9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-24",
    cx: 109.8878,
    cy: 409.9331,
    r: 211.1568,
    gradientTransform: "translate(16.6177 -12.4205) rotate(4.1431)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b6ad4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2523,
    stopColor: "#6d6ed3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#747ad1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7644,
    stopColor: "#7f8ece"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8da8c9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-25",
    cx: 128.725,
    cy: 556.8081,
    r: 314.906,
    gradientTransform: "translate(16.6177 -12.4205) rotate(4.1431)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7835c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#7739c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3624,
    stopColor: "#7345c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5461,
    stopColor: "#6e5ac6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7306,
    stopColor: "#6676c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9141,
    stopColor: "#5c9ac4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56aec4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-26",
    cx: 129.2594,
    cy: 356.6255,
    r: 118.0265,
    gradientTransform: "translate(16.6177 -12.4205) rotate(4.1431)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2151,
    stopColor: "#5e47c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4332,
    stopColor: "#6a52c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6526,
    stopColor: "#7f66ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8718,
    stopColor: "#9b81d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#af94e0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-27",
    cx: 64.021,
    cy: 263.2912,
    r: 159.2193,
    gradientTransform: "translate(16.6177 -12.4205) rotate(4.1431)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a49c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    stopColor: "#5e4dc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4615,
    stopColor: "#6859c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6952,
    stopColor: "#7a6ed0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9286,
    stopColor: "#938adc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c94e0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-28",
    cx: 76.4531,
    cy: 22.4321,
    r: 207.9767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dd0b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2231,
    stopColor: "#50cab8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5299,
    stopColor: "#59b8c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8838,
    stopColor: "#679bcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d90d2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-29",
    cx: 79.0001,
    cy: 86.4815,
    r: 119.0866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dbcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2544,
    stopColor: "#50b8bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#59acc4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7706,
    stopColor: "#6898cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b7fd7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-30",
    cx: 31.3516,
    cy: 218.1791,
    r: 99.4551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ec1b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9946,
    stopColor: "#818cd3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-31",
    cx: 23.3297,
    cy: 139.9479,
    r: 122.8851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4edd9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9183d6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_5_svg__radial-gradient-32",
    cx: 27,
    cy: 158.5154,
    r: 139.6697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#60d0b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#825dd6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "scroll_5_svg__right-bottom"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scroll_5_svg__inner"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,204q-3.5,19.5-7,39L7,260q-3.5,22.5-7,45l31.239,76.333,39.52,21.9125q55.1142-49.8,110.2282-99.5993,7.4943-25.2257,14.9888-50.4513,8.4252-10.678,16.85-21.356,6.76-19.25,13.5193-38.5-3.83-17.1633-7.66-34.3266Q213.3425,121.5063,208,84q-11.5-17.5-23-35L150,19,112,1,56,21,30,59.4615q-8,38-16,76Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "scroll_5_svg__shapes"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31,381l16-4,24,26Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,305l33-6q7,39,14,78l-16,4Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,264l40-11q-5.5,23-11,46L0,305Q2,284.5,4,264Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,235l-39,9L4,264l40-10Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,198l-41,6q-3.5,20-7,40l39-9Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,135l37-15q6.5,39,13,78l-41,6Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,59,59,49q-4,35.5-8,71L14,135Q22,97,30,59Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,21,30,59l28-9L71,23Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,21,112,0,71,23Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-10)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "scroll_5_svg___Layer_",
    "data-name": "<Layer>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71,23l3,3,9,103-34-9q5-35.2692,10-70.5385Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,0l26,25,14-7Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,18l-14,5,45,38,3-15Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,83q-12.5-18.5-25-37-2.5,7.5-5,15,5.5,5.5,11,11Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,128l-33-8q14,29.5,28,59l33-9Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,169l-22,8,13,6,52,16Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.3574,193.01,224,193l-57-65A777.1047,777.1047,0,0,1,115,9q-1.5336-4.5079-3-9l33,21,39,33,27,29Q219.1788,138.005,227.3574,193.01Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,232q7.1787-19.495,14.3574-38.99Q197.6788,160.005,168,127l-10,9-18,54,3,10Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,197l2,8q-2,15.5-4,31L33,299l12-48q5-8.2692,10-16.5385L61,230l68-30Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-19)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.9033,253.522,213,232l-71-35,3,8q23,23,46,46Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-20)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,197q-4,20-8,40,1,3.5,2,7l42,58,3.2474,1.5939q7.328-25.0359,14.6559-50.0719Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-21)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,237,33,299l88,25q7-41.5,14-83Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,237q-7,45-14,90l49-17,12.2474-6.4061Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,322,91,360,43,312,33,299Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,299l59,60q-9.5,20.5-19,41l-2,3a581.22,581.22,0,0,1-29-73Q36.8922,314.0772,33,299Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-25)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.561,377.43,71,403,33,299Q39.78,338.215,46.561,377.43Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-26)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.2205,303.9666,121,322,91,358,71,403Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-27)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,0,71,23q5.5,52.5,11,105l72,4,14-4Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-28)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,128l18,42,42,27q13-35,26-70Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,198l-9,36.4615L142,197Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-30)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,198,49,119l32,58Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-31)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,177l61,20-78,1Z",
    style: {
      fill: "url(#scroll_5_svg__radial-gradient-32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "scroll_5_svg__highlights",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164,125,126,26l43,100,45,52-46-47-18,47,15-49-31-2Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,251l-12,69-37-8,36,11-16,22,20-22,36-12-36,9Z",
    style: {
      fill: "#f2f2f2"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgScroll5);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/scroll_5.c1bf8e9d388728c6f2d9e1b98b8bb789.svg";